import Fragment from 'ember-data-model-fragments/fragment';
import type { Type } from '@warp-drive/core/types/symbols';
import { attr } from '@warp-drive/legacy/model';

// Proto: assessments.GradeScheduleNumeric.Range.
export default class GradescheduleRange extends Fragment {
  declare [Type]: 'assessments/gradeschedule-range';

  @attr('number', { defaultValue: 0 })
  declare start: number;

  @attr('number', { defaultValue: 100 })
  declare end: number;
}
